import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Star({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M10.0544 9.32137C10.0543 9.32164 10.0541 9.32183 10.0538 9.32183H3.76011C3.75947 9.32183 3.75871 9.32265 3.75924 9.32303L8.85132 13.0227C8.85156 13.0228 8.85166 13.0231 8.85157 13.0234L6.90671 19.009C6.90651 19.0097 6.90706 19.0106 6.90759 19.0103L11.9997 15.3106C11.9995 15.3106 11.9998 15.3105 11.9997 15.3106C11.9998 15.3106 12.0004 15.3106 12.0005 15.3106L17.0922 19.01C17.0924 19.0102 17.0931 19.0104 17.0933 19.0102C17.0935 19.0101 17.0937 19.0098 17.0936 19.0095L15.1486 13.0234C15.1485 13.0231 15.1486 13.0228 15.1488 13.0227L20.2405 9.32332C20.2407 9.32319 20.2412 9.32273 20.2412 9.32256C20.2412 9.3222 20.2409 9.32183 20.2405 9.32183H13.9463C13.9462 9.32183 13.9464 9.32188 13.9463 9.32183C13.9462 9.32175 13.9458 9.32153 13.9457 9.32137L12.0008 3.33572C12.0007 3.33511 11.9996 3.33464 11.9994 3.33526L10.0544 9.32137ZM14.9146 7.98849L13.2688 2.92324C12.8694 1.69399 11.1306 1.69443 10.7314 2.92324L9.08556 7.98849H3.75963C2.46712 7.98849 1.93024 9.64228 2.97552 10.4017L7.28429 13.5322L5.63849 18.5975C5.23908 19.8267 6.64602 20.8484 7.6913 20.0889L12.0001 16.9584L16.3088 20.0889C17.3545 20.8487 18.7609 19.8263 18.3616 18.5975L16.7158 13.5322L21.0246 10.4017C22.0703 9.642 21.5326 7.98849 20.2405 7.98849H14.9146Z"
        fill={iconColor}
      />
    </Svg>
  );
}
